import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { ErrorState, LoadingState } from "../../components/states.jsx";
import { useI18n } from "../../i18n/index.js";
import { authClient } from "../../lib/auth-client.js";
import { Brand, CenteredPage, LinkButton } from "../../ui/index.js";

/** While a fresh load reads the session. This page holds no data, only the joining under way, so it shows that already. */
export function InvitationSkeleton() {
  const { t } = useI18n();
  return (
    <CenteredPage>
      <div className="dt-centered__head">
        <Brand size="lg" />
      </div>
      <LoadingState label={t("invitation.joining")} />
    </CenteredPage>
  );
}

// Accept-invitation landing page (the URL sent by the control plane).
export function InvitationRoute() {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await authClient.organization.acceptInvitation({ invitationId: id });
      if (cancelled) return;
      if (error) setError(error.message ?? t("invitation.invalid"));
      else {
        const org = await authClient.organization.getFullOrganization({ query: { organizationId: data.invitation.organizationId } });
        navigate(org.data?.slug ? `/w/${org.data.slug}` : "/", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate, t]);

  return (
    <CenteredPage>
      <div className="dt-centered__head">
        <Brand size="lg" />
      </div>
      {error ? (
        <ErrorState
          title={t("invitation.errorTitle")}
          message={error}
          action={
            <LinkButton to="/" variant="secondary" size="sm">
              {t("invitation.goToWorkspaces")}
            </LinkButton>
          }
        />
      ) : (
        <LoadingState label={t("invitation.joining")} />
      )}
    </CenteredPage>
  );
}
